import React from "react";

// Style \\
import "../../assets/styles/cards/experienceCard.scss";

// Images \\
import doctorAvatar from "../../assets/images/doctorsAvatar.svg";

const ExperienceCard = () => {
  return (
    <div>
      <div className="experienceCard">
        <div className="img">
          <img src={doctorAvatar} alt="img" />
        </div>

        <div className="desc">
          <h4>Surgery</h4>
          <p>
            Share what makes your business unique to set you apart from your
            competition.
            Share what makes your business unique to set you apart from your
            competition.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;
